/*
 *###############################################################################
 *Module Name                   : InvoiceMasterPayment.js                       #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               : Isuru Sampath                                 #
 *Date                          : Friday, October 06th 2023                     #
 *Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */

import CardNumberInput from "framework/components/CardNumberInput";
import DPTextBoxforgrid from "framework/components/DPTextBoxforgrid";
import { getPaymentModeByHedCode, getPaymentModeDetailByDetCode } from "pages/Masters/PaymentModeHed/PaymentModeController";
import React, { useEffect } from "react";
import { useState } from "react";
import { Button, Col, Row } from "reactstrap";
import { Context } from "app-contexts/CommonContexts"
import { useContext } from 'react';
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic";
import { Text, Numeric } from "../../../framework/validators/TextValidation"
import DPAlert from "framework/widgets/DPAlert";

const InvoiceMasterPayment = ({
    setPaymentList,
    paymentList,
    disable,
    menuCode,
    CalculatePaidAmount,
    paidAmount,
    netAmount
}) => {
    const {
        txnDecimalAmt
    } = useContext(Context);

    const changeRowValueChanges = (value, id, element) => {
        const objectIndex = paymentList.findIndex(obj => obj.id === id);
        const newObject = { ...paymentList[objectIndex], [element]: value };
        setPaymentList(prevDataRow => {
            const newDataRow = [...prevDataRow];
            newDataRow[objectIndex] = newObject;
            return newDataRow;
        });
    };


    function handleObjectChange(row, id) {
        const objectIndex = paymentList.findIndex(obj => obj.id === id);
        setPaymentList(prevDataRow => {
            const newDataRow = [...prevDataRow];
            newDataRow[objectIndex] = row;
            return newDataRow;
        });
    }

    function RemoveRow(id) {

        var FilterByRowID = paymentList.filter((item) => item.id !== id);

        if (FilterByRowID.length === 0) { // If there is no rows in the table, add a new row.
            FilterByRowID.push({
                id: 1,
                Paycode: "",
                PayCodeDisable: false,
                Paydesc: "",
                PayDetcode: "",
                PayDetcodeDesable: true,
                PayDetName: "",
                PayAmount: 0,
                PayAmountDisable: true,
                AccountCode: "",
                AccountCodeDisable: true,
                ExpDate: "",
                ExpDateDisable: true,
                PayDetFormat: "",
                IsEditable : true
            })
        }

        const modifiedByID = FilterByRowID.map((item, index) => {
            item.id = index + 1
            return item
        })

        setPaymentList(modifiedByID);
        CalculatePaidAmount(modifiedByID);
    }



    async function AddRow() {

        //if there is a row with empty values, do not add a new row

        const emptyRow = paymentList.find(x => x.Paycode == "");

        if (emptyRow) {
            return false;
        }


        var detailRows = [...paymentList];

        const maxId = detailRows.reduce((max, row) => Math.max(max, row.id), 0);

        detailRows.push({
            id: maxId + 1,
            Paycode: "",
            PayCodeDisable: false,
            Paydesc: "",
            PayDetcode: "",
            PayDetcodeDesable: true,
            PayDetName: "",
            PayAmount: 0,
            PayAmountDisable: true,
            AccountCode: "",
            AccountCodeDisable: true,
            ExpDate: "",
            ExpDateDisable: true,
            PayDetFormat: "",
            IsEditable : true
        })

        const modifiedByID = detailRows.map((item, index) => {
            item.id = index + 1
            return item
        })

        setPaymentList(modifiedByID)

    }


    return (
        <React.Fragment>
            <Row>
                <Col sm={12} md={12} className="mb-12-sm">
                    <table style={{ fontSize: "11px" }} >
                        <thead className="table-light">
                            <tr>
                                <th>#</th>
                                <th>Payment Code</th>
                                <th>&nbsp;</th>
                                <th>Payment Description</th>
                                <th>Detail Code</th>
                                <th>&nbsp;</th>
                                <th>Detail Description</th>
                                <th>Card/Cheque No</th>
                                <th>Cheque Date</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paymentList.map((row, index) => (
                                <TableRow
                                    changeRowValueChanges={changeRowValueChanges}
                                    handleObjectChange={handleObjectChange}
                                    FormRow={row}
                                    Key={index}
                                    disable={disable}
                                    menuCode={menuCode}
                                    paymentList={paymentList}
                                    RemoveRow={RemoveRow}
                                    CalculatePaidAmount={CalculatePaidAmount}
                                    paidAmount={paidAmount}
                                />
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="8"></td>
                                <td>
                                    Paid Amount
                                </td>
                                <td style={{ textAlign: "right" }}>
                                    {paidAmount.toFixed(txnDecimalAmt)}
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="8"></td>
                                <td>
                                    Due Amount
                                </td>
                                <td style={{ textAlign: "right" }}>
                                    {parseFloat(netAmount.toFixed(txnDecimalAmt) - paidAmount.toFixed(txnDecimalAmt)).toFixed(txnDecimalAmt)}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                    <Button
                        onClick={() => {
                            AddRow()
                        }}

                        color="success"
                        className="mt-1"
                        size="sm"
                        disabled={disable}
                    >
                        <i className="mdi mdi-hospital" style={{ fontSize: "12px" }}></i>
                    </Button>
                </Col>
            </Row>
        </React.Fragment>
    )

};


const TableRow = ({ FormRow, changeRowValueChanges, handleObjectChange, Key, disable, menuCode, paymentList, RemoveRow, CalculatePaidAmount, paidAmount }) => {

    const ApiURL = window.Links.ApiURL

    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [groupFilter, SetGroupFilter] = useState("a")
    const [modal_xlargePay, setmodal_xlargePay] = useState(false)
    const [modal_xlargePayDet, setmodal_xlargePayDet] = useState(false)

    useEffect(() => {
        SetGroupFilter("a")
    }, [FormRow]);


    function tog_xlargePay() {
        setmodal_xlargePay(!modal_xlargePay)
    }
    function tog_xlargePayDet() {
        setmodal_xlargePayDet(!modal_xlargePayDet)
    }


    const GetSelectRowPayment = async (e, row, isSelect, rowIndex) => {

        if (CodeValidation(row.PH_CODE, FormRow.id, 1)) {
            GetPaymodeDetails(row.PH_CODE)
            setmodal_xlargePay(!modal_xlargePay)
        } else {
            changeRowValueChanges("", FormRow.id, "Paycode")
            setAlertDescription("Payment Code already used")
            setAlertConfirmOption(4)
            setsweetAlertShow(true)
        }
    }

    const GetSelectRowPayDet = (e, row, isSelect, rowIndex) => {

        const currentRow = FormRow

        // if (CodeValidation(Paycode, "txtPaycode" + Key, row.PD_CODE, "txtPaydetCode" + Key)) {

        GetPaymodeHedDetails(row.PD_CODE)


        setmodal_xlargePayDet(!modal_xlargePayDet)
        // } else {
        //     setAlertDescription("Payment Code already used")
        //     setAlertConfirmOption(4)
        //     setsweetAlertShow(true)
        // }
    }


    const GetPaymodeDetails = async (payModeCode) => {

        if (payModeCode == "") return false

        const response = await getPaymentModeByHedCode(payModeCode)

        if (response.length == 0) {
            setAlertDescription("This payment mode is invalid. Please select another payment mode.")
            setAlertConfirmOption(4)
            setsweetAlertShow(true)
            changeRowValueChanges("", FormRow.id, "Paycode")
            return false
        }

        if (response[0].pH_STATUS == 0) {
            setAlertDescription("This payment mode is inactive. Please select another payment mode.")
            setAlertConfirmOption(4)
            setsweetAlertShow(true)
            changeRowValueChanges("", FormRow.id, "Paycode")
            return false
        }

        if(response[0].pH_LINKGV == 1){
            setAlertDescription("Gift Voucher Payment Mode cannot be used in this transaction.")
            setAlertConfirmOption(4)
            setsweetAlertShow(true)
            changeRowValueChanges("", FormRow.id, "Paycode")
            return false
        }

        const currentRow = FormRow // get the current row data from the FormRow 
        SetGroupFilter(` AND PD_PHCODE = '${response[0].pH_CODE}' `)
        currentRow.Paycode = response[0].pH_CODE
        currentRow.Paydesc = response[0].pH_DESC
        currentRow.PayCodeDisable = true
        currentRow.PayDetcodeDesable = response[0].pH_DETAILS == 1 ? false : true
        currentRow.AccountCodeDisable = response[0].pH_DETAILS == 1 ? false : true
        currentRow.ExpDateDisable = true
        currentRow.PayAmountDisable = response[0].pH_DETAILS == 1 ? true : false
        currentRow.IsEditable = true
        handleObjectChange(currentRow, FormRow.id)

        return true
    }

    const GetPaymodeHedDetails = async (payModeHedCode) => {

        if (payModeHedCode == "") return false

        const response = await getPaymentModeDetailByDetCode(payModeHedCode)

        if (response.length == 0) {
            setAlertDescription("This payment mode detail is invalid. Please select another payment mode detail.")
            setAlertConfirmOption(4)
            setsweetAlertShow(true)
            changeRowValueChanges("", FormRow.id, "PayDetcode")
            return false
        }

        const currentRow = FormRow // get the current row data from the FormRow 


        currentRow.PayDetcode = response[0].pD_CODE
        currentRow.PayDetName = response[0].pD_DESC
        currentRow.PayDetFormat = response[0].pD_FORMAT
        currentRow.PayDetcodeDesable = true
        currentRow.ExpDateDisable = response[0].pD_REQDATE == 1 ? false : true
        currentRow.PayAmountDisable = false

        handleObjectChange(currentRow, FormRow.id)

        return true
    }

    const CodeValidation = (PayCode, id, onclickCheck = 0) => {

        if (onclickCheck == 1) {
            for (let i = 0; i < paymentList.length; i++) {
                const FilteredPayCode = paymentList.filter((item) => item.Paycode == PayCode)
                if (FilteredPayCode.length >= 1) {
                    return false
                }
                return true
            }
        } else {
            for (let i = 0; i < paymentList.length; i++) {
                const FilteredPayCode = paymentList.filter((item) => item.Paycode.toString().toLowerCase() === PayCode.toString().toLowerCase());
                if (FilteredPayCode.length > 1) {
                    return false
                }
                return true
            }
        }
    }

    function ValidatePDCode(value, onclickCheck = 0) {
        if (CodeValidation(value, FormRow.id, onclickCheck)) {
            GetPaymodeDetails(value)
            setmodal_xlargePay(false)
        } else {
            setmodal_xlargePay(false)
            changeRowValueChanges("", FormRow.id, "Paycode")
            setAlertDescription("Payment Code already used")
            setAlertConfirmOption(4)
            setsweetAlertShow(true)
        }
    }

    return (
        <tr>
            <td>{Key + 1}</td>
            <td>
                <DPTextBoxforgrid
                    value={FormRow.Paycode}
                    confirm_both={sweetAlertShow}
                    description={AlertDescription}
                    disabled={disable ? true : FormRow.PayCodeDisable}
                    onChange={(e) => {
                        var value = Text(e.target, 10, true, false, '', false)
                        changeRowValueChanges(value, FormRow.id, "Paycode")
                    }}

                    onBlur={(e) => {
                        ValidatePDCode(e.target.value, 0)
                    }}

                    onKeyPress={(e) => {
                        if (e.key == "Enter") {
                            ValidatePDCode(e.target.value, 0)
                        }
                    }}
                />
            </td>

            <td>
                <Button
                    outline
                    color="success"
                    id={"btnSearch" + Key}
                    disabled={disable ? true : FormRow.PayCodeDisable}
                    size="sm"
                    onClick={tog_xlargePay}
                >
                    <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                    ></i>
                </Button>
            </td>
            <td>
                <DPTextBoxforgrid
                    value={FormRow.Paydesc}
                    disabled={true}
                />
            </td>
            <td>
                <DPTextBoxforgrid
                    value={FormRow.PayDetcode}
                    disabled={disable ? true : FormRow.PayDetcodeDesable}
                    onChange={(e) => {
                        var value = Text(e.target, 10, true, false, '', false)
                        changeRowValueChanges(value, FormRow.id, "PayDetcode")
                    }}
                    onBlur={(e) => {
                        GetPaymodeHedDetails(e.target.value)
                    }}
                    onKeyPress={(e) => {
                        if (e.key == "Enter") {
                            GetPaymodeHedDetails(e.target.value)
                        }
                    }}
                />
            </td>
            <td>
                <Button
                    outline
                    color="success"
                    id={"btnSearch" + Key}
                    disabled={disable ? true : FormRow.PayDetcodeDesable}
                    size="sm"
                    onClick={tog_xlargePayDet}
                >
                    <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                    ></i>
                </Button>
            </td>
            <td>
                <DPTextBoxforgrid
                    value={FormRow.PayDetName}
                    disabled={true}
                />
            </td>
            <td>

                <CardNumberInput
                    value={FormRow.AccountCode}
                    onChange={e => {
                        changeRowValueChanges(e, FormRow.id, "AccountCode")
                    }}
                    //isCard={FormRow.PayDetFormat.includes("-") ? true : false}
                    disabled={disable ? true : FormRow.AccountCodeDisable}
                    placeholder={FormRow.PayDetFormat}
                />
            </td>
            <td>
                <DPTextBoxforgrid
                    value={FormRow.ExpDate}
                    textType={"date"}
                    disabled={disable ? true : FormRow.ExpDateDisable}
                    onChange={e => {
                        changeRowValueChanges(e.target.value, FormRow.id, "ExpDate")
                    }}
                />
            </td>
            <td>
                <DPTextBoxforgrid
                    textAlign={"right"}
                    value={FormRow.PayAmount}
                    disabled={disable ? true : FormRow.PayAmountDisable}
                    onChange={e => {
                        var val = Numeric(e.target, 8, 2, false)

                        if (e.target.value == "") {
                            val = 0
                        }

                        changeRowValueChanges(val, FormRow.id, "PayAmount")
                    }}
                    onBlur={async (e) => {

                        var amount = e.target.value

                        if (e.target.value == "") {
                            amount = 0
                        }

                        await changeRowValueChanges(parseFloat(amount), FormRow.id, "PayAmount")

                        await CalculatePaidAmount()

                    }}
                    onKeyPress={async (e) => {

                        var amount = e.target.value

                        if (e.target.value == "") {
                            amount = 0
                        }

                        if (e.key == "Enter") {
                            await changeRowValueChanges(parseFloat(amount), FormRow.id, "PayAmount")

                            await CalculatePaidAmount()
                        }

                    }}
                />
            </td>
            <DPSearchBoxDynamic
                searchData={[]}
                columns={[]}
                mainTitle={"Payment Search"}
                SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                isOpen={modal_xlargePay}
                toggle={tog_xlargePay}
                getSelect={GetSelectRowPayment}
                APIURL={ApiURL}
                URLPath={"PAYMENT"}
                MenuCode={menuCode}
                KeyVal={"TXN"}
                searchBy={"PH_DESC"}
                FilterStr={groupFilter}
            />
            <DPSearchBoxDynamic
                searchData={[]}
                columns={[]}
                mainTitle={"Payment Detail Search"}
                SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                isOpen={modal_xlargePayDet}
                toggle={tog_xlargePayDet}
                getSelect={GetSelectRowPayDet}
                APIURL={ApiURL}
                URLPath={"PAYMENTDET"}
                MenuCode={menuCode}
                KeyVal={"TXN"}
                searchBy={"PD_DESC"}
                FilterStr={groupFilter}
            />
            <DPAlert
                confirm_both={sweetAlertShow}
                description={AlertDescription}
                showCancel={false}
                btnColor={"success"}
                cancelColor={"danger"}
                onConfirm={() => {
                    setsweetAlertShow(false)
                }}
                onCancel={() => {
                    setsweetAlertShow(false)
                }}
                btnYes={"OK"}
            />
            <td>
                <Button
                    outline
                    disabled={disable ? true : FormRow.IsEditable ? false : true}
                    color="danger"
                    onClick={e => {
                        RemoveRow(FormRow.id)
                    }}
                    size="sm"
                >
                    <i className="mdi mdi-delete" style={{ fontSize: "12px" }}></i>
                </Button>
            </td>
        </tr>


    )

};


export default InvoiceMasterPayment;